var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src && _vm.visiable)?_c('iframe',{staticClass:"pdf__iframe",attrs:{"src":_vm.pdfSrc,"align":"middle"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }